import React, { Fragment } from "react";
import { Link } from "react-router-dom";

const InfoBox = ({ municipio }) => {
  const { img, etapa, nombreUrl, tipoVotacion, msjInfo } = municipio;

  var votacionSubtitulo =
    tipoVotacion === "publica"
      ? "Completá el formulario haciendo click en el botón."
      : "Enterate de cómo y cuándo votar las propuestas presentadas.";

  const obtenerTexto = {
    informativa: {
      //Cada municipio puede editar este mensaje desde la consola; si no lo
      //cargó se muestra el texto por defecto.
      titulo:
        msjInfo && msjInfo.trim() ? msjInfo : "¡Pronto tendremos novedades!",
      subtitulo: "",
    },
    presentacion: {
      titulo: "¡Sumá tus propuestas!",
      subtitulo: "Completá el formulario haciendo click en el botón.",
    },
    votacion: {
      titulo: "¡Votá!",
      subtitulo: votacionSubtitulo,
    },
    seleccion: {
      titulo: "¡Proyectos seleccionados!",
      subtitulo: "Enterate de cuáles son y seguí su ejecución.",
    },
  };

  const obtenerAccion = () => {
    if (nombreUrl === "laboulaye2020" && etapa === "informativa") {
      return (
        <p>
          <a
            href="https://munidigital.com/citizenv2/laboulaye/presupuesto-participativo"
            className="btn btn-lg ppr-btn-verde font-weight-bold"
            target="_blank" // Para abrir en una nueva pestaña
            rel="noopener noreferrer"
          >
            PORTAL DE VOTACIÓN
          </a>
        </p>
      );
    }

    const urls = { presentacion: "presentacion", votacion: "votacion/0" };
    //El texto del botón nombra la acción que el vecino busca, no "FORMULARIO".
    const textos = {
      presentacion: "PRESENTÁ TU PROPUESTA",
      votacion: "VOTÁ ACÁ",
    };
    if (
      etapa === "presentacion" ||
      (etapa === "votacion" && tipoVotacion === "publica")
    ) {
      return (
        <p>
          <Link
            to={`/municipio/${nombreUrl}/${urls[etapa]}`}
            className="btn btn-lg ppr-btn-verde font-weight-bold"
          >
            {textos[etapa]}
          </Link>
        </p>
      );
    }
    return null;
  };

  //Laboulaye 2026 vota en MuniDigital: mientras dura la votación queda en
  //etapa informativa con el botón al portal externo (ver obtenerAccion).
  const texto =
    nombreUrl === "laboulaye2020" && etapa === "informativa"
      ? {
          titulo: "¡Votá!",
          subtitulo:
            "Hacé click en el botón para acceder a la plataforma de votación.",
        }
      : obtenerTexto[etapa];

  return (
    <Fragment>
      <section
        className="infobox-img"
        style={{
          //Sin "fixed": background-attachment:fixed es errático y a menudo se
          //ignora en Safari iOS (parallax roto en el celular).
          background: `url(/img/mun_img/${img}) no-repeat center center / cover`,
        }}
      >
        {/*container (no container-fluid) para que la caja quede alineada
           con el nav y con la tarjeta de contenido de la página.*/}
        <div className="container">
          <div className="row">
            {/*px-md-0: en escritorio el borde de la caja coincide con el de
               la tarjeta blanca; en celular se conserva el margen para que
               se vea la foto del municipio detrás.*/}
            <div className="col-md-5 d-table px-md-0">
              <div className="infobox card card-body d-table-cell align-middle">
                <h1>{texto.titulo}</h1>
                <p>{texto.subtitulo}</p>
                <div className="text-center">{obtenerAccion(etapa)}</div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default InfoBox;
